import request from '@/utils/request'

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/power/setting/user/pageList',
    method: 'get',
    params: query,
  })
}
// 用户列表（下拉框使用）
export function listUserOptions(query) {
  return request({
    url: '/power/setting/user/list',
    method: 'get',
    params: query,
  })
}

// 查询用户详细
export function getUser(query) {
  return request({
    url: '/power/setting/user/detail',
    method: 'get',
    params: query,
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/power/setting/user/add',
    method: 'post',
    data: data,
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/power/setting/user/edit',
    method: 'post',
    data: data,
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: `/power/setting/user/delete/${userId}`,
    method: 'post',
  })
}
// 设置-平台设置-子系统设置-分页列表

export function subsystemList(query) {
  return request({
    url: `/power/setting/subsystem/pageList`,
    method: 'get',
    params: query,
  })
}

// 修改用户个人信息
export function refreshCodeLimit(phone) {
  return request({
    url: `/power/setting/user/refresh/codeLimit/${phone}`,
    method: 'post',
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  return request({
    url: `/power/setting/user/enable/${userId}/${status}`,
    method: 'post',
  })
}

// 个人中心查看
export function getProfileUser(query) {
  return request({
    url: '/power/setting/user/profile',
    method: 'get',
    params: query,
  })
}

// 个人中心--修改
export function getProfileEdit(data) {
  return request({
    url: '/power/setting/user/edit/profile',
    method: 'post',
    data: data,
  })
}
